import { render, staticRenderFns } from "./UnavailableAllowanceYears.vue?vue&type=template&id=048b38ed"
import script from "./UnavailableAllowanceYears.vue?vue&type=script&lang=js"
export * from "./UnavailableAllowanceYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports